/**
 * The withholding reason codes the API sends on `WithheldLossRecord.reason`. It arrives as a
 * plain string, so nothing here is checked against `withholdingReasonCode` at build time.
 */
export const WITHHELD_REASON = {
  stillDisplayed: 'still_displayed',
  copyOnly: 'copy_only',
  payrollAlreadyEnrolled: 'payroll_already_enrolled',
  payrollPerkCouponBanked: 'payroll_perk_coupon_banked',
} as const

/** The rules under which a customer keeps their free-payroll perk through a plan change. */
export const PAYROLL_PERK_KEPT: string[] = [
  WITHHELD_REASON.payrollAlreadyEnrolled,
  WITHHELD_REASON.payrollPerkCouponBanked,
]
